module.exports = __webpack_public_path__ + "sunsemweb/img/pillar-speak-naturally.a9a2249e.png";